<ng-container [ngSwitch]="couponType">
    <ms-correct-score-option-group
        *ngSwitchCase="couponTypes.CorrectScore"
        [couponEvent]="couponEvent"
        [couponGroups]="couponGroups"
        [eventLinkConfig]="linkConfig"
        [media]="media"
        [promotedFixtureIdsMap]="promotedFixtureIds"
        [showParticipantImage]="showParticipantImage"
        [betDetails]="betDetails"
        [tracking]="tracking"
        [favouriteToggle]="favouriteToggle"
        (moreBetsClicked)="moreBetsClicked.emit()"
        (statsClicked)="statsClicked.emit()" />
    <ms-goal-scorer-option-group
        *ngSwitchCase="couponTypes.GoalScorer"
        [event]="couponEvent"
        [showParticipantImage]="showParticipantImage"
        [betDetails]="betDetails"
        [tracking]="tracking"
        [media]="media"
        [periodGroup]="periodGroup" />
</ng-container>
